import { mapGetters, mapActions } from 'vuex';

import { QUERY_PROP_FIELDS } from '../../../config';
import { SEARCH_CHANGE_FIELDS } from '../../../store/actions';

import l10n from '../../../transformers/l10n';

export default {
   computed: {
      ...mapGetters({
         selected: 'getSearchFields',
         isAllSelected: 'isSearchByAllFields'
      }),
      selectedAsCache() {
         if (this.isAllSelected) {
            return {};
         }
         return this.selected.reduce((memo, f) => {
            memo[f] = true;
            return memo;
         }, {});
      },
      items() {
         return QUERY_PROP_FIELDS.map(o => {
            const desc = l10n(o.tk);
            return { ...o, desc, selected: !!this.selectedAsCache[o.field] };
         });
      }
   },
   methods: {
      ...mapActions({
         refreshFields: SEARCH_CHANGE_FIELDS
      }),
      select(item) {
         const { field } = item;
         if ( this.isAllSelected ) {
            this.refreshFields([ field ]);
         } else {
            const fields = item.selected ? this.selected.filter(f => f !== field) : [ ...this.selected, field ];
            if (fields.length) {
               this.refreshFields(fields);
            }
         }
      },
      selectAll() {
         if ( this.isAllSelected ) {
            return;
         }
         this.refreshFields(QUERY_PROP_FIELDS.map(({field}) => field));
      }
   }
};
